import useGetThirdPartyLoanHistory from "../../../../custom-hooks/useGetThirdPartyLoanHistory";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { formatMoney } from "../../../../helpers/formatter";
import moment from "moment/moment";
import ModalContainer from "../../ModalContainer";
import { Button } from "antd";
import styles from "../../LoanOffer/LoanOffer.module.scss";
import React, { Dispatch, SetStateAction, useState } from "react";
import { IThirdPartyInfoPayloadProp } from "../Disburse/CreditAnalysis/DisbursementSummary/DisbursementSummary";
import Paginator from "../../../../components/Pagination/Pagination.component";
import { getTokenFromLocalStorage } from "../../../../helpers/localStorage";
import { BASE_URL } from "../../../../appConstants";

interface ILoanHistory {
  id: number;
  status: string;
  loanAmount: number;
  loanProvider: string;
  repaymentAmount: number;
  repaymentFrequency: string;
  outstandingAmount: number;
  disbursementDateTime: string;
}

interface ILoanHistoryProps {
  customerThirdPartyLoanHistoryPrestate: IThirdPartyInfoPayloadProp;
  onClose: () => void;
  setCustomerThirdPartyLoanHistoryPrestate: Dispatch<
    SetStateAction<IThirdPartyInfoPayloadProp>
  >;
  isDownloadable: boolean;
}

const LoanHistory = ({
  customerThirdPartyLoanHistoryPrestate,
  onClose,
  setCustomerThirdPartyLoanHistoryPrestate,
  isDownloadable,
}: ILoanHistoryProps) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const { data: loanHistoryData, isLoading: isLoadingLoanHistory } =
    useGetThirdPartyLoanHistory(customerThirdPartyLoanHistoryPrestate);

  const handlePaginationChange = (pageNumber: number) => {
    setCustomerThirdPartyLoanHistoryPrestate((prev) => ({
      ...prev,
      Page: pageNumber,
    }));
  };

  const onDownload = () => {
    setIsDownloading(true);

    let token = getTokenFromLocalStorage();

    fetch(
      BASE_URL +
        `/account/loan_disbursement/customer_third_party_loan_history_document?CustomerId=${customerThirdPartyLoanHistoryPrestate?.CustomerId}&AggregatorId=${customerThirdPartyLoanHistoryPrestate?.AggregatorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    ).then((response) => {
      setIsDownloading(false);
      if (response.status === 200 || response.status === 201) {
        response.blob().then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `loan history.csv`);
          link.click();
        });
      }
    });
  };

  let RenderedComponent = null;
  if (isLoadingLoanHistory) {
    RenderedComponent = <p>Loading...</p>;
  } else if (loanHistoryData?.data?.length === 0) {
    RenderedComponent = <p>No loan history information</p>;
  } else {
    RenderedComponent = (
      <div className="d-flex flex-column w-full">
        <MDBTable
          responsive
          minimal="true"
          striped
          bordered
          hover
          id="table-to-xls"
        >
          <MDBTableHead>
            <tr>
              <th>S/N</th>
              <th>Amount</th>
              <th>Repayment Amount</th>
              <th>Outstanding Amount</th>
              <th>Status</th>
              <th>Repayment Frequency</th>
              <th>Loan Provider</th>
              <th>Disbursement Date</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {loanHistoryData?.data?.map(
              (history: ILoanHistory, index: number) => (
                <tr key={history.id}>
                  <td>{index + 1}</td>
                  <td>{formatMoney(history?.loanAmount)}</td>
                  <td>{formatMoney(history?.repaymentAmount)}</td>
                  <td>{formatMoney(history?.outstandingAmount)}</td>
                  <td>{history?.status}</td>
                  <td>{history?.repaymentFrequency}</td>
                  <td>{history?.loanProvider}</td>
                  <td>
                    {moment(history.disbursementDateTime).format(
                      "DD-MMM-YYYY, h:mm a",
                    )}
                  </td>
                </tr>
              ),
            )}
          </MDBTableBody>
        </MDBTable>

        <Paginator
          size={loanHistoryData?.pageSize}
          page={loanHistoryData?.page}
          count={loanHistoryData?.totalCount}
          changeCurrentPage={(value: number) => handlePaginationChange(value)}
        />
      </div>
    );
  }

  return (
    <ModalContainer height={50}>
      <h3 className="d-flex justify-content-center mb-2">
        Customer Loan History
      </h3>
      <div className="d-flex justify-content-between">{RenderedComponent}</div>
      <div style={{ position: "absolute", right: "10px", top: "10px" }}>
        {isDownloadable ? (
          <Button
            className={styles.download_btn}
            onClick={onDownload}
            loading={isDownloading}
          >
            Download
          </Button>
        ) : null}
        <Button className={styles.view_offer_btn} onClick={onClose}>
          Close
        </Button>
      </div>
    </ModalContainer>
  );
};

export default LoanHistory;
